<!-- custom spinner code starts here -->
<div *ngIf="isSpinning" class="spinner-container" id="spinner-container">
  <div class="spinner">
  </div>
</div>
<!-- custom spinner code ends here -->
<div class="home">
  <div class="banner" id="banner">
    <div id="banner-bg-addition"></div>
  </div>
  <div id="banner-bg"></div>
  <div class="gif-container" id="img-item">
    <img [src]="bg" alt="home-bg" id="home-bg" />
  </div>
  <img [src]="constants.VIMEO_IMG" alt="vimeo" id="vimeo-img" />
  <nav class="navbar navbar-home animate__animated animate__slideInDown">
    <!-- navbar left items go here -->
    <div class='nav-item-1'>
      <button class="nav-item-lg" [ngClass]="{'Buy-cofee-button': !isCampaign,'Buy-cofee-button-campaign': isCampaign}">
        <a [href]="constants.SUPPORT_LINK" target="_blank">
          <img [src]="constants.COFFEECUP_IMG" alt="Coffee-icon" class="Coffee-icon" />
          <span class="buy-coffe">{{ constants.BUYUSACOFFEE_TXT }}</span></a>
      </button>
      <a [routerLink]="['/blog']" target="_blank" class="highlight-1 nav-item-lg">Latest News</a>
      <a href="https://windowswapblog.squarespace.com/contact" target="_blank"
        class="highlight-1 nav-item-lg">{{constants.CONTACT_TXT}}</a>
      <a [href]="constants.INSTAGRAM_LINK" target="_blank"
        class="highlight-1 nav-item-lg">{{constants.INSTAGRAM_TXT}}</a>

      <button id="menu-icon" (click)="onMenuOpen()" class="menu_button" [ngClass]="{
        'menu_button': !isLogin,
        'menu_button_login': isLogin}">
        <img [src]="constants.MENU_ICON_IMG" alt="menu" />
      </button>
    </div>
    <!-- navbar left items ends here -->
    <!-- navbar center items start here -->
    <div class='nav-item-2'>
      <p id="title">{{constants.WINDOW_SWAP_TXT}}</p>
    </div>
    <!-- navbar center items ends here -->
    <!-- navbar right items start here -->
    <div class='nav-item-3'>
      <button *ngIf="isLogin" class='submit-button' [routerLink]="['/submit']">{{constants.SUBMIT_TXT}}</button>
      <button *ngIf="!isLogin" [routerLink]="['/login']" class="home-login">{{ constants.LOGIN_TXT }}</button>
      <!-- <button *ngIf="!isLogin" [routerLink]="['/signup']" class="home-signup">{{ constants.JOIN_TXT }}</button> -->
      <button *ngIf="!isLogin" class='submit-button' [routerLink]="['/signup/#']">{{constants.SUBMIT_TXT}}</button>
      <button *ngIf="isLogin && isCampaign && !isMobile" [routerLink]="['/user/mywindow']"
        class="home-Your_window">{{constants.YOUR_PROFILE}}</button>
      <button *ngIf="isLogin && !isCampaign && !isMobile" [routerLink]="['/user']"
        class="home-Your_window">{{constants.YOUR_PROFILE}}</button>
      <div *ngIf="isLogin" class="large-device">
        <div class="menus-data">
          <a><img class="profile-avatar" src="{{ profilePicture }}" /></a>
          <div class="menu">
            <div class="user-menu" id="user-menu">
              <ul>
                <li><a [routerLink]="['/Window']" >{{constants.MENU_ITEMS.WINDOW_VIEWS}}</a></li>
                <li><a [routerLink]="['/submit']">{{constants.MENU_ITEMS.SUBMIT_WINDOW}}</a></li>
                <li><a [routerLink]="['/user/mywindow']">{{constants.MENU_ITEMS.MY_WINDOW}}</a></li>
                <li><a [routerLink]="['/user']">{{constants.MENU_ITEMS.MYBOOKMARK}}</a></li>
                <li><a [routerLink]="['/user/tipjar']">{{constants.MENU_ITEMS.MY_TIPSJAR}}</a></li>
                <li><a [routerLink]="['/sendGift']">Gift WindowSwap</a></li>
                <li><a [routerLink]="['/user-setting']">Settings</a></li>
                <li *ngIf="!showhome" (click)="Takemetoprime()" id="menu-item">
                  <button class="menu-submit-button">{{constants.MENU_ITEMS.GET_ALL_ACCESS}}</button>
                </li>
                <li *ngIf="showhome"><hr class="user-menu-line" /></li>
                <li><button class="user-logout" (click)="logout()">{{constants.MENU_ITEMS.LOGOUT}}</button></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <a *ngIf="isLogin" class="small-device" [routerLink]="['/user']">
        <img *ngIf="!isLoading" class="profile-avatar" src="{{ profilePicture }}" />
      </a>
    </div>
    <!-- navbar right items ends here -->
  </nav>

  <div class="h-button-container" id="buttonItem1" [ngClass]="{'h-button-container':isLogin && showhome,
  'h-button-container-login':isLogin && !showhome,
  'h-button-container-logins':!isLogin}">
    <a class="h-button-border" id="buttonItem3">
      <button id="buttonItem2" class="home-button" (click)="onClickOpenWindow()">
        {{ constants.OPEN_WINDOW_TXT }}
      </button>
      <button *ngIf="isPrime" class="map-search" (click)="onClickSearch()">
        <img class="control-icon" src="{{ constants.SEARCH_NO_SHADOW_IMG }}" alt="map search" />
      </button>
    </a>
  </div>
  <div class="d-flex justify-content-center align-items-center  mobile_btns_logins" *ngIf="!isLogin">


    <div class="pr-2"> <button class="sec_2_submit-button" [routerLink]="['/submit']">
        <a>

          <span class="buy-coffe">{{ constants.SUBMIT }}</span></a>
      </button></div>

    <div class="pl-2"> <button [ngClass]="{
    'sec_2_Buy-cofee-button': !isCampaign,
    'Buy-cofee-button-campaign': isCampaign
  }">
        <a [href]="constants.SUPPORT_LINK" target="_blank">
          <img [src]="constants.COFFEECUP_IMG" alt="Coffee-icon" class="Coffee-icon" />
          <span class="buy-coffe">{{ constants.BUYUSACOFFEE_TXT }}</span></a>
      </button></div>
  </div>


  <div class="d-flex justify-content-center align-items-center mobile_btns" *ngIf="isLogin && !showhome">
    <div class="pr-2"> <button class="sec_2_submit-button" [routerLink]="['/submit']">
        <a>

          <span class="buy-coffe">{{ constants.SUBMIT }}</span></a>
      </button></div>

    <div> <button [ngClass]="{
    'sec_2_Buy-cofee-button': !isCampaign,
    'Buy-cofee-button-campaign': isCampaign
  }">
        <a [href]="constants.SUPPORT_LINK" target="_blank">
          <img [src]="constants.COFFEECUP_IMG" alt="Coffee-icon" class="Coffee-icon" />
          <span class="buy-coffe">{{ constants.BUYUSACOFFEE_TXT }}</span></a>
      </button></div>
  </div>

</div>
<div class="section-2">

      <div class="flex-end-center-aligned home_attr_1 ">
        <img [src]="constants.VIMEO_IMG" alt="vimeo" id="vimeo_img_1" class="vimeo_img_1"/>
        <a [href]="constants.TERMS_CONDITIONS_LINK"  style="text-decoration:none;"><span class="T_C">{{
          constants.TERMS_CONDITIONS_TXT
          }}</span></a>
      </div>
  <small *ngIf="showhome && isLogin" class="small_option">{{constants.OR_SELECT_A_WINDOW_PLAYLIST_TXT}}</small>
  <div class="container my-container" *ngIf="showhome && isLogin">
    <img [src]="constants.blurb_img" class="blurb-images " id="image1" />
    <div class="large-screen">
      <div class="col_IMG" (click)="getvalue('Interiors')">
        <a><img class="col-img" src="{{ constants.INTERIOR_IMG }}" height="30px" width="30px" /></a>
        <span class="caption"> <small>{{constants.TAG_GROUP.INTERIOR}}</small></span>
      </div>
      <div class="col_IMG" (click)="getvalue('City')">
        <a>
          <img class="col-img" src="{{ constants.CITY_IMG }}" height="30px" width="30px" /></a>
        <span class="caption"><small>{{constants.TAG_GROUP.CITY}}</small></span>
      </div>
      <div class="col_IMG" (click)="getvalue('Nature')">
        <a><img class="col-img" src="{{ constants.NATURE_IMG }}" height="30px" width="30px" /></a>

        <span class="caption"><small>{{constants.TAG_GROUP.NATURE}}</small></span>
      </div>
      <div class="col_IMG" (click)="getvalue('Animals')">
        <a>
          <img class="col-img" src="{{ constants.PETS_IMG }}" height="30px" width="30px" /></a>
        <span class="caption"><small>{{constants.TAG_GROUP.PETS}}</small></span>
      </div>
      <div class="col_IMG" (click)="getvalue('Rain')">
        <a class="d-block"><img class="col-img" src="{{ constants.RAIN_IMG }}" height="30px" width="30px" /></a>
        <span class="caption"> <small>{{constants.TAG_GROUP.RAIN}}</small></span>
      </div>
      <div class="col_IMG" (click)="getvalue('Snow')">
        <a><img class="col-img" src="{{ constants.SNOW_IMG }}" height="30px" width="30px" /></a>

        <span class="caption"><small>{{constants.TAG_GROUP.SNOW}}</small></span>
      </div>
      <div class="col_IMG" (click)="getvalue('Night')">
        <a><img class="col-img" src="{{ constants.NIGHT_IMG }}" height="30px" width="30px" /></a>
        <span class="caption"><small>{{constants.TAG_GROUP.NIGHT}}</small></span>
      </div>
      <div class="col_IMG" (click)="getvalue('Water')">
        <a><img class="col-img" src="{{ constants.WATER_IMG }}" height="30px" width="30px" /></a>
        <span class="caption"><small>{{constants.TAG_GROUP.WATER}}</small></span>
      </div>
    </div>

  </div>
  <small *ngIf="showhome && isLogin" class="small_option_1">WINDOWSWAP PLAYLIST</small>
  <div class="container my-container" *ngIf="showhome && isLogin">
    <img [src]="constants.blurb_img_2" class="blurb-images " id="image2" />
    <div id="small-screen">
      <div class="row small_row">
        <div class="col-3">
          <div class="col_IMG_small" (click)="getvalue('INTERIOR')">
            <a><img class="col-img" src="{{ constants.INTERIOR_IMG }}" height="30px" width="30px" /></a>
            <span class="caption"> <small>{{constants.TAG_GROUP.INTERIOR}}</small></span>
          </div>
        </div>
        <div class="col-3">
          <div class="col_IMG_small" (click)="getvalue('City')">
            <a>
              <img class="col-img" src="{{ constants.CITY_IMG }}" height="30px" width="30px" /></a>
            <span class="caption"><small>{{constants.TAG_GROUP.CITY}}</small></span>
          </div>
        </div>
        <div class="col-3">
          <div class="col_IMG_small" (click)="getvalue('Nature')">
            <a><img class="col-img" src="{{ constants.NATURE_IMG }}" height="30px" width="30px" /></a>

            <span class="caption"><small>{{constants.TAG_GROUP.NATURE}}</small></span>
          </div>
        </div>
        <div class="col-3">
          <div class="col_IMG_small" (click)="getvalue('Animals')">
            <a>
              <img class="col-img" src="{{ constants.PETS_IMG }}" height="30px" width="30px" /></a>
            <span class="caption"><small>{{constants.TAG_GROUP.PETS}}</small></span>
          </div>
        </div>
      </div>
      <div class="row small_row_1">
        <div class="col-3">
          <div class="col_IMG_small" (click)="getvalue('Rain')">
            <a class="d-block"><img class="col-img" src="{{ constants.RAIN_IMG }}" height="30px" width="30px" /></a>
            <span class="caption"> <small>{{constants.TAG_GROUP.RAIN}}</small></span>
          </div>
        </div>
        <div class="col-3">
          <div class="col_IMG_small" (click)="getvalue('Snow')">
            <a><img class="col-img" src="{{ constants.SNOW_IMG }}" height="30px" width="30px" /></a>

            <span class="caption"><small>{{constants.TAG_GROUP.SNOW}}</small></span>
          </div>
        </div>
        <div class="col-3">
          <div class="col_IMG_small" (click)="getvalue('Night')">
            <a><img class="col-img" src="{{ constants.NIGHT_IMG }}" height="30px" width="30px" /></a>
            <span class="caption"><small>{{constants.TAG_GROUP.NIGHT}}</small></span>
          </div>
        </div>
        <div class="col-3">
          <div class="col_IMG_small" (click)="getvalue('Water')">
            <a><img class="col-img" src="{{ constants.WATER_IMG }}" height="30px" width="30px" /></a>
            <span class="caption"><small>{{constants.TAG_GROUP.WATER}}</small></span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center align-items-center  mobile_btn" *ngIf="isLogin && showhome">
  
    <div class="pr-2"> <button class="sec_2_submit-button" [routerLink]="['/submit']">
        <a>
          <span class="buy-coffe">{{ constants.SUBMIT }}</span></a>
      </button></div>
  
    <div class="pl-2"> <button [ngClass]="{
      'sec_2_Buy-cofee-button': !isCampaign,
      'Buy-cofee-button-campaign': isCampaign
    }">
        <a [href]="constants.SUPPORT_LINK" target="_blank">
          <img [src]="constants.COFFEECUP_IMG" alt="Coffee-icon" class="Coffee-icon" />
          <span class="buy-coffe">{{ constants.BUYUSACOFFEE_TXT }}</span></a>
      </button></div>
  </div>

  <div class="conatiner mt-N25" [ngClass]="{'pb-5': !showhome}">
  
    <!-- Gifting -->
    <div class="gift_1" [ngClass]="{'gift-pt': showhome && isLogin}">
      <div class="d-flex justify-content-center align-items-center flex-column w-100 gift">
        <img class="gift_img" src="{{ constants.WS_GIFT }}" alt="" />
        <p class="m-0 pt-2 pb-2 gift_text">{{constants.GIFT_PARA}}</p>
        <button class="giftBtn" [routerLink]="'/sendGift'">{{constants.GIFT_ALL_ACCESS}}</button>
      </div>
    </div>
  
    <div class="row sec_2_row_1 mt-45" *ngIf=" !showhome ">
      <!-- The section below is commented out because Publift ads need to be removed. -->
      <!-- <div class="col-12 ads-wrapper marginB-37">
          <div data-fuse="23173945071" id="window_header_desktop" class="window_header"></div>
          <div data-fuse="23197864273" id="window_header_tablet" class="window_header"></div>
        </div> -->
      <div class="col-8 all_access_img">
        <img class="payment_img" src="{{ constants.WINDOW_SWAP }}" alt="" />
      </div>
      <div class="col-4 d-flex flex-column">
        <div class="WINDOWSWAP_TEXT_div">
          <p class="WINDOWSWAP_TEXT_P">WINDOWSWAP ALL-ACCESS</p>
        </div>
        <hr>
        <div class="allaccess_TEXT_HEAD">
          <p class="payment_card_text_1">
            Get access to all
            windows ever uploaded,
            unlimited bookmarks,
            playlists and even a
            back button.
          </p>
          <button (click)="Takemetoprime()" class="payment_card_btn">{{constants.UPGRADE_5_TXT}}
          </button>
        </div>
      </div>
  
    </div>
  
  </div>
  <div class="sec_2_row_1_mobile d-flex justify-content-center align-items-center flex-column container"
    *ngIf="!showhome">
    <div> <img class="w-100  " [ngClass]="{
      'window-access-login': !isLogin ,
      'window-access-logins': isLogin && !showhome }" src="{{ constants.WINDOW_SWAP }}" alt="" /></div>
    <!-- The section below is commented out because Publift ads need to be removed. -->
    <!-- <div class="col-12 ads-wrapper pb-5">
      <div data-fuse="23197864045" id="window_header_mob" class="window_header"></div>
    </div> -->
    <div class="text-center">
      <p class="payment_card_text_1_mobile">
        All windows ever uploaded, <br />
        unlimited bookmarks, playlists <br />
        and even a back button. <br />
      </p>
      <button (click)="Takemetoprime()" class="payment_card_btn">{{constants.UPGRADE_5_TXT}}</button>
    </div>
  </div>

  
  <div class="tipJar_container">
    <img class="w-100" src="{{ constants.THE_TIP_JAR }}" alt="" />
    <div class="d-flex justify-content-center align-items-center flex-column tip_jar_text">
      <p class="tip_jar_text_heading">{{constants.THE_TIPS_JAR}}</p>
      <p class="tip_jar_text_1">{{constants.SEND_TIPS_TXT}}</p>
      <button *ngIf="isLogin" [routerLink]="['/user/tipjar']"
        class="tip_jar_text_btn">{{constants.FIND_OUT_HOW_TXT}}</button>
      <button *ngIf="!isLogin" [routerLink]="['/blog/tipjar']" target="_blank"
        class="tip_jar_text_btn">{{constants.FIND_OUT_HOW_TXT}}</button>
    </div>
    <small class="tipJar_Location_1">{{constants.ALLESSIO_TXT}}</small>
  </div>
  <div class="tipJar_container_1 ">
    <img class="w-100" src="{{ constants.WS_tipjar_mobile }}" alt="" />
    <div class="d-flex justify-content-center align-items-center flex-column tip_jar_text">
      <p class="tip_jar_text_heading">{{constants.THE_TIPS_JAR}}</p>
      <p class="tip_jar_text_1_mobile">{{constants.SEND_TIPS_TXT}}</p>
      <button *ngIf="isLogin" [routerLink]="['/user/tipjar']"
        class="tip_jar_text_btn">{{constants.FIND_OUT_HOW_TXT}}</button>
      <button *ngIf="!isLogin" [routerLink]="['/blog/tipjar']" target="_blank"
        class="tip_jar_text_btn">{{constants.FIND_OUT_HOW_TXT}}</button>
      <small class="tipJar_Location">{{constants.ALLESSIO_TXT}}</small>
    </div>
  </div>
  <div class=" large-device" [ngClass]="{ 
    'survy_1': !isLogin  ,
    'survy_1-login': isLogin && !showhome ,
    'survy_1-logins': isLogin && showhome
   }">
   <div class="d-flex justify-content-center align-items-center flex-column w-100 " style="height: 92%;">
      <img class="survay_IMG" src="{{ constants.WS_survy_mobile }}" alt="" />
      <p class="m-0 pt-pb-1rem survy_TEXT">{{constants.SURVEY_PARA}}</p>
      <button [ngClass]="{'survy-BTN': !isLogin && !showhome, 'survy-BTNS': isLogin && !showhome ,
      'survy-BTN-logins': isLogin && showhome}"
        (click)="goToLink('https://docs.google.com/forms/d/e/1FAIpQLSexKoDrAipn4I1kab-3rh5dZ8zEn4O5WipG_s43InpPCYAbiw/viewform')">{{constants.TAKE_SURVEY}}</button>
        <!-- The section below is commented out because Publift ads need to be removed. -->
        <!-- <div class="col-12 ads-wrapper marginB-37" style="margin-top: 37px;" *ngIf="!isPrime || !isLogin">
          <div data-fuse="23174194651" id="window_incontent_desktop" class="window_incontent"></div>
          <div data-fuse="23198728802" id="window_incontent_tablet" class="window_incontent"></div>
        </div> -->
      </div>
  </div>

  <div class=" sec_2_row_1_mobile" [ngClass]="{ 
    'survy_1': !isLogin  ,
    'survy_1-login': isLogin && !showhome ,
    'survy_1-logins': isLogin && showhome
   }">
    <div class="d-flex justify-content-center align-items-center flex-column w-100 h-100">
      <img class="survay_IMG" src="{{ constants.WS_survy_mobile }}" alt="" />
      <p class="m-0 pt-2 pb-2 survy_TEXT_MOBILE">{{constants.SURVEY_PARA}}</p>
      <button class="" [ngClass]="{'survy-BTN': !isLogin && !showhome, 'survy-BTNS': isLogin && !showhome ,
      'survy-BTN-logins': isLogin && showhome}"
        (click)="goToLink('https://docs.google.com/forms/d/e/1FAIpQLSexKoDrAipn4I1kab-3rh5dZ8zEn4O5WipG_s43InpPCYAbiw/viewform')">{{constants.TAKE_SURVEY}}</button>
        <!-- The section below is commented out because Publift ads need to be removed. -->
        <!-- <div class="col-12 ads-wrapper mtb-25" *ngIf="!isPrime || !isLogin">
          <div data-fuse="23197864360" id="window_incontent_mob" class="window_incontent"></div>
        </div> -->
    </div>
  </div>
  <div class="conatiner pt-5">
    <div class="row sec_2_row_1">
      <div class="col-8 all_access_img">
        <div class="payment_img " id='vimeo1'></div>
      </div>
      <div class="col-4 d-flex flex-column">
        <div class="WINDOWSWAP_TEXT_div">
          <p class="WINDOWSWAP_TEXT_P">{{constants.WINDOWSWAP_ARTISTS_TXT}}</p>
        </div>
        <hr>
        <div class="allaccess_TEXT_HEAD">
          <p class="payment_card_text_1">
            50 Windows. 30 <br />
            Countries. 3 Artists. <br />
            1 Digital Choir. <br />
            1 worldwide collaborative <br />
            music video.
          </p>
        </div>
      </div>
    </div>
    <div class="sec_2_row_1_mobile d-flex justify-content-center align-items-center flex-column container pb-5">
      <div>
        <div id="vimeo"></div>
      </div>
      <div class="text-center">
        <p class="music_card_text_1_mobile">
          50 Windows. 30 Countries.<br />
          3 Artists.1 Digital Choir. <br />
          1 worldwide collaborative <br />
          music video.
        </p>
      </div>
    </div>
  </div>
  <footer id="Footer-item" class="Footer_item">
    <div class="d-flex justify-content-center align-items-center" id="footer">
      <a class="anchor-img" [href]="constants.INSTAGRAM_LINK" target="_blank"><img [src]="constants.INSTAGREM_IMG"
          alt="instagram" class="instagremIcon" /></a>

      <a class="anchor-img" [routerLink]="['/blog']" target="_blank"><img [src]="constants.NEWS_IMG" alt="latestnews"
          class="latestIcon" /></a>

      <a class="anchor-img" href="https://windowswapblog.squarespace.com/contact" target="_blank"><img
          [src]="constants.CONTACT_IMG" alt="contact" class="contactIcon" /></a>

      <a class="anchor-img" [href]="constants.TERMS_CONDITIONS_LINK" ><img [src]="constants.TERMS_IMG"
          alt="contact" class="tc" /></a>
    </div>
  </footer>
</div>
<div class="mobile-menu" id="mobile-menu">
  <div class="close-button-container">
    <button class="menu-close-button" (click)="onMenuClose()">
      <img id="close-button" [src]="constants.CLOSE_BUTTON" alt="close-button" />
    </button>
  </div>
  <li>
    <a [routerLink]="['/blog']">{{ constants.BLOG_TXT }}</a>
    <a href="https://windowswapblog.squarespace.com/contact">{{
      constants.CONTACT_TXT
      }}</a>
    <a [href]="constants.SUPPORT_LINK" target="_blank">{{
      constants.BUYUSACOFFEE_TXT
      }}</a>
    <a [routerLink]="['/submit']">{{ constants.MENU_ITEMS.SUBMIT_WINDOW }}</a>
    <a (click)="Takemetoprime()" *ngIf="!showhome" class="cursor-btn">{{constants.MENU_ITEMS.GET_ALL_ACCESS}}</a>
    <a [routerLink]="['/sendGift']">Gift WindowSwap</a>
    <a [routerLink]="['/user-setting']">Settings</a>
    <a *ngIf="isLogin" style="color: #ca7358" (click)="logout()" class="cursor-btn">{{constants.MENU_ITEMS.LOGOUT}}</a>
    <a *ngIf="!isLogin" [routerLink]="['/signup']">Sign up</a>
  </li>
  <div class="insta-menu-button">
    <a [href]="constants.INSTAGRAM_LINK" target="_blank"><img [src]="constants.INSTAGRAM_IMG" alt="instagram"
        class="insta-menu" /></a>
  </div>
  <a class="menu-terms" [href]="constants.TERMS_CONDITIONS_LINK">{{ constants.TERMS_CONDITIONS_TXT
    }}</a>
</div>